import { SelectOptionType } from '@octano/global-ui';

export type AcademicLevelListItem = {
  id: number;
  name: string;
};

export type SchoolType = {
  id: number;
  code: string;
  name: string;
  description: string;
};

export interface CoursesFeaturesOptions {
  replaceCourseGradeAllowed: boolean;
  replaceEvaluationGradeAllowed: boolean;
  workingDaysToResumeEvaluation: number | null;
}

type Base = {
  id: number;
  name: string;
};

export type CourseFormData = Partial<{
  schools: SelectOptionType[];
  academicLevels: SelectOptionType[];
  activities: SelectOptionType[];
  modalities: SelectOptionType[];
  studyPlanVersions: SelectOptionType[];
  courseTypes: SelectOptionType[];
  replaceCourseGradeOptions: SelectOptionType[];
  coursesFeatures?: CoursesFeaturesOptions | null;
}>;

export type CourseSyllabus = {
  id: number;
  name: string;
  extension: string;
  url?: string;
};

export type CourseAttendance = {
  minPercentage: number;
  activityTypeId: number;
};

export type CourseAssistanceRequirements = CourseAttendance & {
  id: number;
  courseId: number;
  createdAt: string;
  updatedAt: string;
};

export type Course = {
  id: number;
  shortening: string;
  code: string;
  name: string;
  credits: number;
  totalHours?: number;
  presentialPedagogicalHours?: number | null;
  schoolId: number;
  academicLevelId: number;
  modalityId: number | null;
  replaceCourseGradeAllowed: boolean;
  semesterCourses?: any[];
  sections?: any[];
  types: Base[];
  assistanceRequirements: CourseAssistanceRequirements[];
  compatibilities: CourseCompatibility[];
  dependsOn: CoursePrerequisite[];
  syllabus: CourseSyllabus | null;
  createdAt: string;
  updatedAt: string;
  courseLearningResults: CourseLearningResult[];
  courseLearningUnits: CourseLearningUnit[];
  hasLearningUnits?: boolean;
};

export type CourseCompatibility = {
  id: number;
  shortening: string;
  name: string;
  credits: number;
};

export type CoursePrerequisite = {
  id: number;
  shortening: string;
  name: string;
  credits: number;
};

export type CourseLearningResult = {
  id?: number;
  code?: string;
  description?: string;
  indexOnTable?: number;
};

export type CourseLearningUnit = {
  id?: number;
  title?: string;
  hours?: string;
  indexOnTable?: number;
};

export type CourseFormFields = {
  // CourseDetailsSection
  shortening: Course['shortening'];
  code: Course['code'];
  name: Course['name'];
  credits: string;
  totalHours: string;
  presentialPedagogicalHours: string | null;
  school: SelectOptionType | null | undefined;
  academicLevel: SelectOptionType | null | undefined;
  modality: SelectOptionType | null | undefined;
  replaceCourseGradeAllowed: SelectOptionType | null | undefined;
  // CourseTypeSection
  courseTypes: number[];
  // CourseActivityTypeSection
  attendance: CourseAttendance[];
  // CourseSyllabusSection
  syllabusFile: File | null;
  // CourseCompatibilitiesSection
  compatibilities: CourseCompatibility[];
  // CoursePrerequisitesSection
  prerequisites: CoursePrerequisite[];
  // CourseFooterSection
  learningResults: CourseLearningResult[];
  // CourseLerningUnitSection
  learningUnits: CourseLearningUnit[];
};

export enum replaceCourseGradeAllowedCode {
  Enabled = 'enabled',
  Disabled = 'disabled',
}
